<template>
  <div>
    <section class="d-sm-none mobile-card-select pt-0">
      <div class="checkout-card sticky-top-cls">
        <h4>{{ _T('Checkout') }}</h4>
        <div id="open-cart" class="back-cart" @click="closemobilecartpayment()">
          <svg width="24" height="24" fill="none">
            <use xlink:href="#left_arrow" />
          </svg>
        </div>
      </div>
      <template v-if="cart_items_count">
        <template v-if="payment_needed">
          <div class="select-card">
            <h6>{{ _T('Select Card') }}</h6>
            <div class="add-new-card desired-time">
              <div class="box-checkbox">
                <ul>
                  <li
                    v-for="(card, key) in customer_saved_credit_cards"
                    :key="key"
                  >
                    <label>
                      <input
                        class="radio_animated"
                        id="chk-ani18"
                        type="radio"
                        v-model="selectedPaymentMethod"
                        :value="'savedcard.' + card.card_id"
                        checked
                      />
                      <span>
                        <div class="media">
                          <img
                            :src="
                              '/images/checkout/' + card_image(card.card_type)
                            "
                            alt
                            class="img-fluid"
                          />

                          <div class="media-body">
                            <h6>{{ _T(card.card_type) }}</h6>
                            <span>XXXX-XXXX-XXXX-{{ card.card_last4 }}</span>
                          </div>
                        </div>
                      </span>
                    </label>
                  </li>
                  <li v-if="!customer_saved_credit_cards.length">
                    <p>{{ _T(`You don't have any card saved yet`) }}</p>
                  </li>

                  <li>
                    <div>
                      <label>
                        <input
                          class="radio_animated"
                          id="chk-ani18"
                          type="radio"
                          v-model="selectedPaymentMethod"
                          value="creditcard"
                        />
                        <span>
                          <div class="media">
                            <div class="credit-svg">
                              <svg width="25" height="20" class="m-0">
                                <use xlink:href="#visa" />
                              </svg>
                              <svg width="25" height="20" class="mtminus5">
                                <use xlink:href="#mastercard" />
                              </svg>
                            </div>
                            <div class="media-body">
                              <h6>{{ _T('Credit/Debit Card') }}</h6>
                              <span>{{ _T('Add new card here') }}</span>
                            </div>
                          </div>
                        </span>
                      </label>
                      <!-- <a href="#" data-toggle="modal" data-target="#myModal1" >
                    <span><i class="fas fa-plus mr-3"></i></span>
                    {{ _T('Add New Card') }}
                  </a> -->
                    </div>
                  </li>
                  <div
                    class="credit-card-form pt-4"
                    v-show="selectedPaymentMethod == 'creditcard'"
                  >
                    <credit-card-form></credit-card-form>
                  </div>
                </ul>
              </div>
            </div>
          </div>
          <div class="select-card">
            <h6>{{ _T('Other Method') }}</h6>
            <div class="add-new-card desired-time">
              <div class="box-checkbox">
                <ul>
                  <li>
                    <label>
                      <input
                        class="radio_animated"
                        id="chk-ani20"
                        type="radio"
                        value="COD"
                        v-model="selectedPaymentMethod"
                        name="rdo-ani2"
                      />
                      <span>
                        <div class="media">
                          <img
                            src="/images/checkout/method.jpg"
                            alt
                            class="img-fluid"
                          />
                          <div class="media-body">
                            <h6>{{ _T('Cash On Delivery') }}</h6>
                            <span>{{ _T('Pay when your order arrives') }}</span>
                          </div>
                        </div>
                      </span>
                    </label>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </template>
        <div v-else class="media loyalty">
          <div class="media-body details">
            <div class="timeline-card">
              <h6 class="text-center mb-2">
                {{
                  _T(
                    'You have used cashback as a payment method. Cashback points you are using are'
                  )
                }}
              </h6>
              <div class="loyalty-points">
                {{ currency }} {{ Num.price(loyalty_spent) }}
              </div>
            </div>
          </div>
        </div>

        <div class="bill-amount">
          <h6>
            {{ _T('Bill Amount') }}
            <span
              >{{ currency }} {{ Num.price(order_total_inc_cashback) }}</span
            >
          </h6>
          <progress-bar
            v-if="processInProgress(process)"
            :btn-large="true"
            uiBlock
          ></progress-bar>
          <template v-else>
            <button
              @click.stop="checkout()"
              class="btn btn-solid btn-block"
              :class="{ disabled: btnDisabled }"
            >
              {{ _T('Place order') }}
            </button>
          </template>
        </div>
      </template>
    </section>
    <!-- <card-model></card-model> -->
  </div>
</template>

<script>
import CreditCardForm from '@/components/Blocks/CreditCardForm.vue'
import ProgressBar from '@/components/Elements/ProgressBar'
import Checkout from '@/mixins/Checkout'
import { mapGetters } from 'vuex'

export default {
  name: 'MobileCheckout',
  mixins: [Checkout],
  computed: {
    selectedPaymentMethod: {
      get() {
        return this.$store.state.payment_store.selectedPaymentMethod
      },
      set(val) {
        this.$store.commit('SELECT_PAYMENT_METHOD', val)
      },
    },
    ...mapGetters(['cart_items_count', 'payment_needed']),
  },
  methods: {
    card_image(type) {
      let img = 'mastercard.png'

      switch (type) {
        case 'VISA':
          img = 'visa.png'
          break
      }
      return img
    },
    closemobilecartpayment() {
      this.$router.replace({
        name: this.brandStoreRoute('cart'),
        // params: { ...this.brandStoreParams },
      })
    },
  },
  components: {
    CreditCardForm,
    ProgressBar,
  },
}
</script>

<style lang="scss" scoped>
.mobile-card-select {
  height: 100vh;
  position: relative;
  &.open {
    position: fixed;
    display: block;
    top: 0;
    right: 0;
    width: 100%;
    z-index: 999;
    background: $white;
  }
  .checkout-card {
    text-align: center;
    padding: $px18 $px20;
    background-color: $white;
    border-bottom: $px12 solid $light-border;
    h4 {
      position: relative;
      margin-bottom: 0;
      font-weight: bold;
      text-transform: capitalize;
      .skip-this {
        font-weight: 600;
        font-size: $px14;
        line-height: $px17;
        letter-spacing: 0.02em;
        color: $light-font;
        position: absolute;
        right: $px2;
        top: $px4;
      }
    }
    .back-cart {
      position: absolute;
      top: $px18;
      left: $px20;
      z-index: 1;
    }
  }
  .my-account {
    padding: $px10 $px20 $px10;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: $px1 solid $light-border;
    h4 {
      margin-bottom: 0;
      font-weight: 600;
      font-size: $px18;
      letter-spacing: -0.02em;
    }
    .badge {
      float: right;
      color: rgba(var(--color-warning-color-source), 0.8);
      font-weight: normal;
      font-size: $px14;
      line-height: $px17;
      letter-spacing: 0.583333px;
      padding: $px4 $px10;
      background-color: rgba(var(--color-warning-color-source), 0.2);
      border-radius: $px6;
    }
  }
  .loyalty-point {
    > h6 {
      font-weight: 600;
      font-size: $px12;
      line-height: $px15;
      letter-spacing: 0.02em;
      color: $light-font;
      margin-bottom: 0 !important;
      text-transform: uppercase;
    }
    .media {
      margin-top: $px20;
      .media-body {
        margin-left: $px18;
        h6 {
          line-height: $px17;
          letter-spacing: 0.02em;
        }
        h4 {
          font-weight: 600;
          font-size: $px18;
        }
      }
    }
    ul {
      li {
        display: block;
        padding: $px26 0;
        a {
          color: $font-color;
          display: block;
        }
        + li {
          border-top: $px1 solid $light-border;
        }
        svg {
          vertical-align: -$px6;
        }
        h6 {
          display: inline-block;
          margin-bottom: 0;
          margin-left: $px4;
        }
        span {
          float: right;
        }
        .version {
          margin-left: 0;
          font-weight: normal;
          font-size: $px13;
          line-height: $px16;
          letter-spacing: 0.02em;
          color: $light-font;
        }
      }
    }
    .logout-btn {
      padding-bottom: $px65;
      button {
        border-width: $px2;
        svg {
          vertical-align: bottom;
          margin-right: $px2;
          path {
            fill: $color-primary;
          }
        }
        &:hover {
          svg {
            path {
              fill: $white;
            }
          }
        }
      }
    }
  }
  .media-user {
    padding: $px16;
    align-items: center;
    img {
      padding: $px4;
      border: $px1 solid $light-border;
      border-radius: 100%;
      width: $px74;
      height: $px74;
    }
    .media-body {
      padding-left: $px12;
      h5 {
        font-weight: 600;
        font-size: $px16;
        color: $black;
        margin-bottom: $px3;
      }
      span {
        font-size: $px13;
        line-height: $px16;
        display: block;
        letter-spacing: 0.02em;
        color: $light-font;
        margin-bottom: $px6;
      }
      a {
        font-weight: 600;
        font-size: $px13;
        line-height: $px16;
      }
    }
    &.text-center {
      img {
        width: $px82;
        height: $px82;
      }
      .change-photo {
        position: relative;
        a {
          &.icon-change {
            width: $px30;
            height: $px30;
            background-color: $color-primary;
            display: flex;
            align-items: center;
            justify-content: center;
            border: $px1 solid $white;
            border-radius: 100%;
            position: absolute;
            right: 40%;
            bottom: 0;
            img {
              padding: 0;
              border: none;
              width: auto;
              height: auto;
            }
          }
        }
        input {
          position: absolute;
          left: 0;
          right: 0;
          margin: 0 auto;
          width: $px28;
          opacity: 0;
          bottom: 0;
          cursor: pointer;
        }
      }
    }
  }
  .select-card {
    padding: $px20;
    margin-bottom: $px12;
    + .select-card {
      margin-bottom: $px120;
      @media (max-width: 575px) {
        margin-bottom: $px170;
      }

      border-top: $px12 solid $light-border;
    }
    h6 {
      font-weight: 600;
      line-height: $px22;
      letter-spacing: 0.5px;
      margin-bottom: $px4;
    }
    .add-new-card {
      margin-top: 0;
      ul {
        li {
          display: block;
          label {
            span {
              text-align: left;
              padding: $px10 $px15;
              .media {
                .media-body {
                  margin-left: $px14;
                  span {
                    border: none;
                    padding: 0;
                    line-height: $px17;
                    letter-spacing: 0.04em;
                    color: $light-font;
                  }
                }
              }
            }
          }
          .link-add-card {
            padding: $px18;
            text-align: center;
            border: $px1 dashed $light-border;
            border-radius: $px4;
            a {
              font-weight: 600;
              letter-spacing: 0.04em;
            }
          }
        }
      }
    }
  }
  .added-product {
    li {
      display: flex;
      position: relative;
      min-height: $px87;
      &:last-child {
        min-height: $px70;
      }
      .detail {
        margin-left: $px18;
        width: 100%;
        h6 {
          font-weight: 600;
          font-size: $px14;
          line-height: $px17;
          letter-spacing: 0.02em;
          color: $font-color;
          text-transform: capitalize;
          margin-bottom: $px2;
          span {
            float: right;
          }
        }
        p {
          max-width: $px180;
          font-weight: normal;
          font-size: $px13;
          line-height: $px16;
          letter-spacing: 0.5px;
          color: $light-font;
          text-overflow: ellipsis;
          white-space: normal;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          display: -webkit-box;
          overflow: hidden;
          margin-bottom: 0;
        }
        a {
          font-weight: 600;
          font-size: $px14;
          line-height: $px17;
          letter-spacing: 0.02em;
          color: $warning-color;
          align-items: center;
          display: flex;
          margin-top: $px6;
          svg {
            margin-left: $px3;
          }
        }
      }
      .qty-box {
        margin-left: 0;
        position: absolute;
        right: 0;
        bottom: 0;
        .form-control {
          width: $px32;
          height: $px32;
        }
        .input-group {
          .btn {
            width: $px32;
          }
        }
      }
      + li {
        padding-top: $px20;
        margin-top: $px20;
        border-top: $px1 solid $light-border;
      }
    }
    .btn-add {
      width: 100%;
      border: $px1 dashed $light-border;
      border-radius: $px4;
      font-weight: 600;
      font-size: $px14;
      line-height: $px17;
      letter-spacing: 0.04em;
      color: $color-primary;
      background-color: white;
      text-transform: capitalize;
      padding: $px15;
    }
  }
  &.profile-account {
    height: auto;
    .checkout-card {
      text-align: left;
      border-bottom: none;
      padding: 0;
      h4 {
        padding: $px10 $px20 $px10 $px50;
        border-bottom: $px1 solid $light-border;
        font-weight: 600;
      }
      .back-cart {
        top: $px10;
        .back-loyalty,
        .back-carry {
          img {
            width: $px16;
          }
        }
      }
    }
    .select-card {
      + .select-card {
        margin-bottom: 0;
      }
    }
  }
  .bill-amount {
    padding: $px15 $px20;
    border-top: $px18 solid $light-border;
    background-color: $white;
    position: fixed;
    width: 100%;
    bottom: 0;
    z-index: 2;
    h6 {
      font-weight: bold;
      line-height: $px17;
      letter-spacing: 0.005em;
      margin-bottom: $px10;
      span {
        float: right;
        font-size: $px16;
        line-height: $px19;
      }
    }
  }
}
.desired-time {
  margin-top: calc(#{$px20} + (50 - 20) * ((100vw - #{$px320}) / (1920 - 320)));
  .box-checkbox {
    ul {
      margin: 0;
      li {
        label {
          margin-bottom: 0;
          width: 100%;
          position: relative;
          cursor: pointer;
          .radio_animated {
            float: right;
            margin-right: $px6;
            margin-top: $px5;
            opacity: 0;
            &:after {
              border-radius: $px2;
              background-color: $white;
              border: none;
            }
            &:before {
              transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
              transform: rotate(-45deg) scale(0, 0);
              left: $px3;
              top: $px1;
              z-index: 1;
              width: 0.75rem;
              height: 0.375rem;
              border: $px2 solid $white;
              border-top-style: none;
              border-right-style: none;
              background: $transparent;
              border-radius: 0;
            }
            &:checked {
              opacity: 1;
              &:after {
                background-color: $color-primary;
              }
              &:before {
                transform: rotate(-45deg) scale(1, 1);
              }
              ~ span {
                border: $px2 solid $color-primary;
                transition: all 0.5s ease;
                color: $color-primary;
              }
            }
          }
          span {
            padding: calc(
              #{$px8} + (15 - 8) * ((100vw - #{$px320}) / (1920 - 320))
            );
            border: $px2 solid $light-border;
            display: block;
            border-radius: $px4;
            transition: all 0.5s ease;
            font-weight: 600;
            font-size: calc(
              #{$px14} + (16 - 14) * ((100vw - #{$px320}) / (1920 - 320))
            );
            line-height: $px19;
            text-align: center;
            letter-spacing: 0.02em;
          }
        }
        &.col-sm-6 {
          &:nth-child(odd) {
            padding: 0;
          }
          &:nth-child(even) {
            padding-right: 0;
          }
        }
      }
    }
    .timing-checkbox {
      padding-top: calc(
        #{$px16} + (30 - 16) * ((100vw - #{$px320}) / (1920 - 320))
      );
      margin-top: calc(
        #{$px16} + (30 - 16) * ((100vw - #{$px320}) / (1920 - 320))
      );
      border-top: $px1 solid $light-border;
      height: $px346;
      overflow: auto;
      &::-webkit-scrollbar {
        width: 0 !important;
      }
      li {
        label {
          span {
            border: $px2 solid $light-font;
            background: $light-font;
          }
          .radio_animated {
            &:after {
              background: $light-font;
            }
            &:checked {
              ~ span {
                background-color: $white;
              }
            }
            &:disabled {
              ~ span {
                color: rgba(var(--color-font-color-source), 0.3);
              }
            }
          }
        }
        + li {
          + li {
            margin-top: $px15;
          }
        }
      }
    }
  }
  h4 {
    margin-bottom: calc(
      #{$px8} + (10 - 8) * ((100vw - #{$px320}) / (1920 - 320))
    ) !important;
  }
}
.credit-svg {
  border: 1px solid $light-border;
  padding: 0 $px10;
  border-radius: $px2;
  svg {
    height: $px20;
    display: block !important;
    &.mtminus5 {
      margin-top: -5px !important;
    }
  }
}
.credit-card-form {
  border-radius: $px4;
  margin-top: $px20;
  border: $px2 solid $light-border;
  .chk-outline {
    margin: 0 $px15 $px15;
  }
}
@media (max-width: 575px) {
  .desired-time {
    max-height: 40vh !important;
    overflow: auto;
    .box-checkbox {
      ul {
        li {
          &.col-sm-6 {
            &:nth-child(odd),
            &:nth-child(even) {
              padding-left: 0;
            }
          }
          + li {
            margin-top: $px15;
          }
        }
      }
    }
  }
}
.loyalty {
  display: flex;
  align-items: center;
  padding: $px12;
  margin-top: 50%;
  .timeline-card {
    background-color: rgba($color: #000000, $alpha: 0.05);
    transition: background-color 0.5 ease-in;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: $px12;
  }
  .details {
    h6 {
      font-style: normal;
      font-weight: 600;
      font-size: $px14;
      line-height: $px22;
      letter-spacing: 0.005em;
      color: $font-color;
      margin-bottom: 0;
    }
    .loyalty-points {
      margin-top: $px16;
      font-weight: 600;
      font-size: $px14;
      line-height: $px22;
      letter-spacing: 0.005em;
      background: $warning-color;
      color: #fff;
      padding: $px8 $px12;
      border-radius: $px6;
    }
  }
}
.body-rtl {
  // @media (max-width: 575px) {
  .mobile-card-select {
    text-align: right;
    .bill-amount {
      h6 {
        span {
          float: left;
        }
      }
    }
  }
  .desired-time {
    .box-checkbox {
      ul {
        padding-right: 0;
      }
    }
  }
}
// }
</style>
